import reactCSS from 'reactcss';
import { gu2px } from '@ux/theme-utils';
import { modifier } from '@ux/style-utils';
import {
  footnote,
} from '@ux/type-size';
import { AvailabilityStatus } from '../../../core/constants';

export default ({
  theme,
  isMinMd,
  availability,
}) => {
  const {
    palette,
    spacing,
    typography,
  } = theme;

  return reactCSS({
    default: {
      availability: {
        ...footnote(typography),
        marginBottom: gu2px(1, spacing),
        marginRight: gu2px(1, spacing),
      },

      availabilityIcon: {
        width: gu2px(3, spacing),
        height: gu2px(3, spacing),
        display: 'inline-block',
        verticalAlign: 'middle',
        lineHeight: 1,
        marginLeft: gu2px(2, spacing),
      },

      availabilityText: {
        display: 'inline-block',
        verticalAlign: 'middle',
      },

      buttonText: {
        whiteSpace: 'nowrap',
      },
    },

    isMinMd: {
      availability: {
        display: 'inline-block',
        marginRight: gu2px(2, spacing),
      },
    },


    [modifier('availability', AvailabilityStatus.VERIFYING)]: {
      availability: {
        color: palette.grey12,
      },
    },

    [modifier('availability', AvailabilityStatus.AVAILABLE)]: {
      availability: {
        color: palette.primaryContrast,
        fill: palette.green01,
      },
    },

  }, [
    isMinMd,
    availability,
  ]);
};
